import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { BASE_URL } from "../config";

export const apiIsCancelled = (exception) => {
  return axios.isCancel(exception);
};

export const apiGET = (url, config) => {
  return axios.get(BASE_URL + url, { ...config, withCredentials: true });
};

export const apiPOST = (url, data, config) => {
  return axios.post(BASE_URL + url, data, { ...config, withCredentials: true });
};

export const useAPI = (url, params, resultCallback) => {
  const [result, setResult] = useState({ status: "pending" });

  const refresh = useCallback(
    (signal) => {
      setResult({ status: "pending" });
      apiGET(url, {
        signal,
        params,
      })
        .then((result) => {
          const handleResult = resultCallback ?? ((result) => result.data);
          setResult(handleResult(result));
        })
        .catch((error) => {
          if (apiIsCancelled(error)) {
            console.log(`request ${url} aborted!`);
            return;
          }
          setResult({ status: "error", error });
        });
    },
    [url, params, resultCallback]
  );

  useEffect(() => {
    const controller = new AbortController();
    refresh(controller.signal);
    return () => {
      controller.abort();
    };
  }, [refresh]);

  return [result, refresh];
};
